import { render } from "./PartnerGamesModal.vue?vue&type=template&id=0615201c&scoped=true"
import script from "./PartnerGamesModal.vue?vue&type=script&lang=js"
export * from "./PartnerGamesModal.vue?vue&type=script&lang=js"

import "./PartnerGamesModal.vue?vue&type=style&index=0&id=0615201c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0615201c"]])

export default __exports__